import { Component, Input, OnChanges  } from '@angular/core';

import { HisNotificationService, HisUploadFile, HisUiService } from 'hisng';

import { PublicationFileImportService } from '../../../service/iface/publication-file-import.service';

@Component({
    selector: 'res-publication-file-import',
    templateUrl: './publication-file-import.component.html'
})
export class PublicationFileImportComponent {
    @Input() fileImportService: PublicationFileImportService;
    @Input() fileUploadConfigKey: string;

    uploadFiles: HisUploadFile[] = [];

    constructor(
        private notificationService: HisNotificationService,
        private hisUiService: HisUiService,) {
    }

    public doImport(file: HisUploadFile) {
        console.log('PublicationFileImportComponent #uploadFiles', file);

        if (!file) {
            this.notificationService.errorI18n('fs.res.publication.import.noFileSelectedNotification');
            return;
        }
        
        this.fileImportService.uploadPublicationImportFile(file).subscribe(result => {
            if(result) {
                // XXX differs from the convenience methods in notificationService, can we unify these?
                this.notificationService.success(
                    this.hisUiService.translate('fs.res.publication.import.started', file.name),
                    this.hisUiService.translate('messagebox.singleSuccessTitle')
                );
                
                this.uploadFiles.length = 0;
            }
        });
        
    }

}
